import React from 'react';

const ConfirmationModal = ({ isOpen, onConfirm, onCancel, message }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
      <div className="bg-white rounded-xl p-6 max-w-sm w-full shadow-lg">
        <h3 className="text-lg font-raleway font-bold text-primary mb-4">{message}</h3>
        <p className="text-secondary font-montserrat mb-6">
         Your assessment will be submited now.
        </p>
        <div className="flex justify-end space-x-4">
          <button
            onClick={onCancel}
            className="admin-btn btn-outlined px-6 py-2 rounded-full font-montserrat text-sm"
          >
            No
          </button>
          <button
            onClick={onConfirm}
            className="admin-btn btn-primary px-6 py-2 rounded-full font-montserrat text-sm"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;